import { useState } from 'react';
import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { BUTTON_SIZES, DestructiveButton } from 'ui/button';
import { Checkbox, CHECKBOX_STATUS } from 'ui/checkbox';
import { RUMHelpers } from 'services/observability/datadog';

import { PredictiveAudienceGoal } from '../../types';
import { createActionName } from '../../observabilityUtils';
import { ConditionsContainer, ModalConditionsText, ModalText, StyledMonospace } from '../Styled';

export type DeleteModalProps = {
  /** Header text for delete modal. */
  goal: PredictiveAudienceGoal;
  /** Callback function to delete widget when close is click. */
  onClose: () => void;
  /** Callback function to delete widget when comfirm is click. */
  deleteGoal: () => void;
  /* Used for accessibility attributes, and not visual control */
  isModalOpen: boolean;
};

export const DeleteModal = ({ deleteGoal, goal, isModalOpen, onClose }: DeleteModalProps) => {
  const [conditionsConfirmed, updateConditions] = useState(false);

  const toggleConditions = () => {
    updateConditions((prevState) => !prevState);
  };
  const checkboxStatus = conditionsConfirmed ? CHECKBOX_STATUS.CHECKED : CHECKBOX_STATUS.UNCHECKED;
  return (
    <Modal
      id={'deleteGoalModal'}
      isModalOpen={isModalOpen}
      onClose={onClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DELETE}
    >
      <ModalHeader>Delete goal?</ModalHeader>
      <ModalBody>
        <ModalText>
          Deleting your predictive goal, <b>{goal.name}</b>, cannot be undone.
        </ModalText>
        <ModalText>
          All campaigns, workflows, templates, and lists that reference the{' '}
          <StyledMonospace>{goal.userProfileField}</StyledMonospace> user field will be impacted.
        </ModalText>
        <ConditionsContainer>
          <Checkbox
            id="deleteGoalModal_checkbox"
            status={checkboxStatus}
            onClick={toggleConditions}
          />
          <ModalConditionsText>
            Yes, delete my <b>{goal.name}</b> predictive goal.
          </ModalConditionsText>
        </ConditionsContainer>
      </ModalBody>
      <ModalFooter
        onClose={() => {
          RUMHelpers.addRUMAction(createActionName('Cancel goal deletion'), {
            goalName: goal?.name,
          });
          onClose();
        }}
      >
        <DestructiveButton
          onClick={deleteGoal}
          isDisabled={!conditionsConfirmed}
          size={BUTTON_SIZES.LARGE}
        >
          Delete goal
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
